import { AlgoliaSearchService, AlgoliaRecommendService } from '@b2ag/search'
import OfferService from '@b2ag/offers/src/services/offer.service'
import algoliasearch from 'algoliasearch/lite'
import recommend from '@algolia/recommend'
import { AuthLocationStorage, useAuthService } from '@b2ag/auth'
import { createAxiosClientWithAladinBearer } from '@b2ag/axios'
import { DiscountService } from '@b2ag/discount'
import { StoreService } from '@b2ag/coop-store'
import RecommendationService from '@b2ag/product/src/services/recommendation.service'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import CartService from '@b2ag/cart/src/cart.service'
import LineItemService from '@b2ag/cart/src/line-item.service'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { createShoppingListApiClient } from '@b2ag/legacy-shared-shopping-list-sdk'
import CooperativeService from '@b2ag/cooperative/src/cooperative.service'
import UserService from '@b2ag/user/src/user.service'
import ProfileService from '@b2ag/profile/src/profile.service'
import { i18n } from '@b2ag/locale'
import { getConfig } from '@b2ag/micro-front-tools'

export { productService } from '@b2ag/product/src/dependency-injection'

const cartApiHost = getConfig('CART_API_HOST')
const offerApiHost = getConfig('OFFER_API_HOST')
const productApiHost = getConfig('PRODUCT_API_HOST')
const discountApiHost = getConfig('DISCOUNT_API_HOST')
const userApiHost = getConfig('USER_API_HOST')
const searchAppId = getConfig('ALGOLIA_APP_ID')
const searchApiKey = getConfig('ALGOLIA_API_KEY')
const shoppingListApiHost = getConfig('SHOPPING_LIST_API_HOST')!

const accessTokenSource = () => useAuthService().getAccessToken()
const logger = useLogger()
const callerId = buildCallerId()

export const algoliaClient = algoliasearch(searchAppId, searchApiKey)
export const searchService = new AlgoliaSearchService(algoliaClient)
export const algoliaRecommendClient = recommend(searchAppId, searchApiKey)
export const recommendService = new AlgoliaRecommendService(algoliaRecommendClient)
export const cooperativeService = new CooperativeService(userApiHost)
export const cartService = new CartService({ cartApiHost })
export const lineItemService = new LineItemService({ cartApiHost })
export const offerService = new OfferService(createAxiosClientWithAladinBearer(offerApiHost, { callerId, i18n }))
export const profileService = new ProfileService(userApiHost)
export const discountService = new DiscountService({ discountApiHost })
export const recommendationService = new RecommendationService(productApiHost)
export const userService = new UserService(userApiHost)
export const storeService = new StoreService({ userApiHost })

export const locationStorage = import.meta.browser
  ? new AuthLocationStorage(localStorage)
  : { storeLocation: () => {}, afterLoginPath: '/' }

export const shoppingListApiClient = createShoppingListApiClient({
  shoppingListApiHost,
  useCartV2: true,
  accessTokenSource,
  logger,
})
